<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Copyright © 2022 by Aaron Foley</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">All rights reserved. This book or any portion thereof may not be reproduced or used in any manner whatsoever without the express written permission of the publisher except for the use of brief <br/>quotations in a book review.</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Printed in the United States of America</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">First edition 2022<br/>1 2 3 4 5 6 7 8 9</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Ebook ISBN: </span><span class="CharOverride-1">978-1-953368-37-9</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1"><img alt="" class="_idGenObjectAttribute-2" src="image/notches.png"/></span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Belt Publishing</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">5322 Fleet Avenue</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Cleveland, Ohio 44105</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">www.beltpublishing.com</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Cover art by David Wilson</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Book design by Meredith Pangrace</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" src="image/page1.png"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Boys-Epub-1.vue?63658fdc